import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserData } from "../features/auth/authSlice";
import {
  checkStripeAccountStatus,
  generateAccountSetupLink,
} from "../features/Payment/paymentSlice";
import { notifyError } from "../utils/notificationMsg";
import { useNavigate } from "react-router-dom";
import {
  fetchAllIndustryData,
  fetchAllMasterData,
} from "../features/Recruiter/candidateSlice";
import {
  fetchUniversities,
  fetchUniversitiesDegrees,
} from "../features/Recruiter/universitySlice";
const GlobalDataContext = createContext();
const API_KEY =
  "5663koR1eC6wjk4Nm08QvSwiq9VbSy5Fq1IcJkAPxCoTAZl4UODlJQQJ99AJACYeBjFKmeWjAAAgAZMPHzSv";
const libraries = ["places"];

export const GlobalDataProvider = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, loading: authLoading } = useSelector((state) => state?.auth);
  const {
    _id,
    user_type,
    subscriptions,
    user_contracturl,
    stripe_accountstatus,
    stripe_auth,
  } = user ?? {};
  const userId = _id?.$oid;
  const [stripeLoading, setStripeLoading] = useState(false);

  const handleGenerateLink = useCallback(
    async (Id) => {
      setStripeLoading(true);
      try {
        const { payload } = await dispatch(
          generateAccountSetupLink({ _id: Id })
        );
        if (payload.status === 200) {
          window.location.href = payload.response.url;
        } else {
          notifyError("Failed to generate account link.");
        }
      } catch (error) {
        notifyError("Error generating account setup link.");
      } finally {
        setTimeout(() => setStripeLoading(false), 20000);
      }
    },
    [dispatch]
  );

  const checkStripeAccount = async (userId) => {
    try {
      const { payload } = await dispatch(
        checkStripeAccountStatus({ _id: userId })
      );
      if (payload.status === 200) {
        if (payload.subscriptions?.length === 0) {
          navigate("/user-subscription");
        } else if (
          payload.account_status === "" &&
          payload.stripe_status === ""
        ) {
          navigate("/dashboard");
        }
        //  else if (payload.stripe_status === "inprocess") {
        //   navigate("/dashboard");
        // }
      } else {
        notifyError("Failed Stripe Account Status");
      }
    } catch (error) {
      notifyError("An error occurred while checking Stripe account.");
    }
  };

  const handlecheckStripeStatus = async (userId) => {
    if (user_type === "recruiter") {
      checkStripeAccount(userId);
    } else if (subscriptions?.length !== 0) {
      navigate("/dashboard");
    }
    // else if (user_contracturl && user_contracturl !== "") {
    //   navigate("/dashboard");
    // } else {
    //   navigate("/contract-details");
    // }
  };

  const fetchData = useCallback(async () => {
    if (userId) {
      dispatch(fetchUserData(userId));
    }
    // if (!stripe_auth) {
    //   handlecheckStripeStatus(userId);
    // }
  }, [userId]);
  function getUserMasterData() {
    if (userId) {
      dispatch(fetchAllMasterData());
      dispatch(fetchAllIndustryData());
      dispatch(fetchUniversities({ universityname: "" }));
      dispatch(fetchUniversitiesDegrees({ degreename: "" }));
    }
  }
  useEffect(() => {
    getUserMasterData();
  }, [dispatch, userId]);

  useEffect(() => {
    if (user_type !== "admin") {
      fetchData();
    }
  }, [dispatch, userId, user_type, stripe_accountstatus]);

  return (
    <GlobalDataContext.Provider
      value={{
        fetchData,
        handleGenerateLink,
        handlecheckStripeStatus,
        checkStripeAccount,
        subscriptions,
        stripeLoading,
        authLoading,
        API_KEY,
        libraries,
        userId,getUserMasterData
      }}
    >
      {children}
    </GlobalDataContext.Provider>
  );
};

export const useGlobalData = () => useContext(GlobalDataContext);
